<template>
  <div class="project-selector">
    <b-dropdown v-if="selected.name" :disabled="isInvoiced" id="dropdown-form" class="dropdown-form" variant="light" block :text="getSelectedName(selected)" ref="dropdown">
      <b-dropdown-header id="dropdown-header-1">
        <b-form-input v-model="filters.search_by_name" :placeholder="$gettext('Search...')" @input="debounceSearch" />
      </b-dropdown-header>
      <b-dropdown-divider />
      <ul class="dropdown-innerlist list-unstyled">
        <b-dropdown-item-button @click="unassignHour(!isInvoiced)" id="tooltip-unassign">
          {{ $gettext("Nothing selected") }}
        </b-dropdown-item-button>
        <b-tooltip :disabled="!isInvoiced" target="tooltip-unassign">{{ $gettext('Cannot unassign project if this hour status is invoiced.') }}</b-tooltip>
        <b-dropdown-group v-for="customer in customerList" :key="customer.id" :header="customer.name">
          <b-dropdown-item-button v-for="project in customer.projects" :key="project.id" @click="projectClicked(project)">
            {{ project.name }}
          </b-dropdown-item-button>
        </b-dropdown-group>
      </ul>
      <b-dropdown-divider v-if="showNextBtn" />
      <div class="load-more-wrapper" v-if="showNextBtn">
        <GekkoButton 
          @click="loadMore"
          :text="$gettext('Load more')"
          icon="fa-solid fa-plus"
          class="text-blue" 
          size="sm" 
          variant="link"
          :disabled="(!next)"
        />
      </div>
    </b-dropdown>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import CustomerService from "@/store/services/customer.service.js";
import ProjectService from "@/store/services/project.service.js";
import GekkoButton from "@/components/GekkoButton";

export default {
  name: "HoursProjectSelector",
  components: { GekkoButton },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    isInvoiced: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: { name: this.$gettext("Loading projects...") },
      customerList: [],
      customerName: '',
      debounceTime: 1000,
      next: null,
      showNextBtn: false,
      filters:{ extended: true, contains_project: "True", owner_company: null, is_archived: "False", remove_archived_projects: "True" }
    }
  },
  computed: {
    ...mapGetters({ 
      getCompanyId: 'main/getCompanyId'
    }),
  },
  created() {
    this.filters.owner_company = this.getCompanyId
    this.getCustomerList(this.value);
  },
  methods: {
    getSelectedName (project) {
      const customerName = this.customerList.find(customer => customer.id === project.company)
      return project.name + (customerName ? ' | ' + customerName.name : '')
    },
    getCustomerList (value) {
      CustomerService.listPaginated(this.filters).then((response) => {
        this.customerList = response.data.results;
        this.next = response.data.next;
        this.showNextBtn = response.data.next;
        if(value && value.id){
          ProjectService.retrieve(value.id).then((response) => {
            this.selected = response.data;
          })
        } else {
          this.selected = {}
          this.selected.name = this.$gettext("Nothing selected")
        }
      })
    },
    loadMore (e) {
      e.preventDefault()
      CustomerService.listNextPage(this.next).then((response) => {
        this.customerList.push(...response.data.results);
        this.next = response.data.next;
      })
    },
    projectClicked (project) {
      this.selected = project;
      this.$emit('input', project);
      this.$emit('change', project);
    },
    unassignHour (allow) {
      if (allow) {
        this.selected = {}
        this.selected.name = this.$gettext("Nothing selected")
        this.$emit('deselect')
      }
    },
    debounceSearch () {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
          CustomerService.listPaginated(this.filters).then((response) => {
            this.next = response.data.next;
            this.customerList = response.data.results;
            this.$nextTick(() => {
              if (this.$refs.dropdown?.show) this.$refs.dropdown.show()
            })
          })
      }, this.debounceTime)
    }
  }
};
</script>
<style lang="scss">
.project-selector {
  min-height: 36px;
  .dropdown-toggle {
    border: 0;
    background: $inputBackgroundColor;
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%) !important;
    text-align: left;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-right: 25px;
    
    &:hover, &:active, &:focus { background: $inputBackgroundColor; }
    &:after {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .dropdown-menu { width: 100%; }
  .dropdown-header { 
    padding: 0.5rem;
    input {
      border: 0;
      box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
      background-color: $inputBackgroundColor;
    }
  }
  .dropdown-innerlist {
    max-height: 300px;
    overflow-y: scroll;
  }
}
.load-more-wrapper {
  text-align: center;
}
</style>